module.exports = __webpack_public_path__ + "img/chinesecompany64.db54bbed.png";